import queryString from "query-string";

export default (url, params, type, signal) => {
  const fetchURL =
    url + (!url.indexOf("?") > 0 ? "&" : "?") + queryString.stringify(params);

  return fetch(fetchURL, { signal })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      if (err.name === "AbortError") {
        return; // Continuation logic has already been skipped, so return normally
      }
      console.error(err);
    });
};
